import clsx from 'clsx'
import { CSSProperties, FC, useState } from 'react'
import Placeholder from 'react-bootstrap/Placeholder'

import PathUtil from '@/utils/pathUtil'
import TypeUtil from '@/utils/typeUtil'

type ImageProps = {
  src?: string
  alt?: string
  className?: string
  width: string | number
  height: string | number
  isLoading?: boolean
  animation?: 'wave' | 'glow'
}

const Image: FC<ImageProps> = ({ src, alt, className, width, height, isLoading, animation }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const style: CSSProperties = {
    width,
    height,
    overflow: 'hidden',
  }

  const placeholderStyle: CSSProperties = {
    ...style,
    backgroundColor: 'var(--kt-gray-300)',
    backgroundImage: `url("${PathUtil.toAbsoluteURL('/media/logos/logo-placeholder.png')}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '60% auto',
    backgroundPosition: 'center center',
  }

  if (isLoading) {
    return (
      <Placeholder
        as="div"
        animation={animation}
        className={clsx(
          'd-flex justify-content-center align-items-center fw-medium fs-6',
          className,
          isLoading ? '' : 'text-muted'
        )}
        style={style}
      />
    )
  }

  return (
    <div
      className={className}
      style={isLoaded ? style : placeholderStyle}
    >
      <img
        className={clsx('w-100 h-100', {
          'd-none': !TypeUtil.isDefined(src),
        })}
        src={src}
        alt={alt}
        style={{ objectFit: 'contain' }}
        onLoad={(e) => {
          setIsLoaded(true)
          e.currentTarget.style.display = 'block'
        }}
        onError={(e) => {
          setIsLoaded(false)
          e.currentTarget.style.display = 'none'
        }}
      />
    </div>
  )
}

export type { ImageProps }

export default Image
